import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetDocumentListTktResultEffect } from './get-document-list-tkt-result.effect';
import { getDocumentListTktResultReducer } from './get-document-list-tkt-result.reducer';
import {
  GET_DOCUMENT_LIST_TKT_RESULT_STORE_NAME,
  GetDocumentListTktResultState,
} from './get-document-list-tkt-result.state';

/** Token of the GetDocumentListTktResult reducer */
export const GET_DOCUMENT_LIST_TKT_RESULT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<GetDocumentListTktResultState, Action>
>('Feature GetDocumentListTktResult Reducer');

/** Provide default reducer for GetDocumentListTktResult store */
export function getDefaultGetDocumentListTktResultReducer() {
  return getDocumentListTktResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_DOCUMENT_LIST_TKT_RESULT_STORE_NAME, GET_DOCUMENT_LIST_TKT_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([GetDocumentListTktResultEffect]),
  ],
  providers: [
    { provide: GET_DOCUMENT_LIST_TKT_RESULT_REDUCER_TOKEN, useFactory: getDefaultGetDocumentListTktResultReducer },
  ],
})
export class GetDocumentListTktResultStoreModule {
  public static forRoot<T extends GetDocumentListTktResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetDocumentListTktResultStoreModule> {
    return {
      ngModule: GetDocumentListTktResultStoreModule,
      providers: [{ provide: GET_DOCUMENT_LIST_TKT_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
